import { render, staticRenderFns } from "./DialogInteractionDetails.vue?vue&type=template&id=15168c98&"
import script from "./DialogInteractionDetails.vue?vue&type=script&lang=js&"
export * from "./DialogInteractionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports